import type { SegmentMst } from '@libs/domain';
import type { RequestType } from '@libs/templates/mst';
import { MstRegistrationTmpl } from '@libs/templates/mst';
import type { PageProps } from '@ps-smart-cp/ppfw-client';
import { withRerender } from '@ps-smart-cp/ppfw-client';
import { highOrderAdditionalInfo } from './components';
import { useSegmentMstSettings } from './hooks';
import { SegmentMstRegistration } from './models';
import { fetchMst, register, update } from './repositories';
import { createSegmentMstItemName, createSegmentMstRegistrationFieldConfig } from './services';

function PageComponent({
  type,
  segmentMstKey,
  ...restProps
}: PageProps & Pick<RequestType, 'type'> & Pick<SegmentMst['schema'], 'segmentMstKey'>) {
  const segmentMstSettings = useSegmentMstSettings();
  const requestType =
    type === 'new'
      ? { type, registrationFunction: register(segmentMstKey)() }
      : {
          type,
          updateFunction: update(segmentMstKey)(),
          fetchFunction: fetchMst(segmentMstKey)(),
        };

  return (
    <MstRegistrationTmpl
      mstName={createSegmentMstItemName(segmentMstKey, segmentMstSettings)}
      initMst={SegmentMstRegistration.init}
      items={createSegmentMstRegistrationFieldConfig(segmentMstKey, segmentMstSettings)}
      {...requestType}
      {...restProps}
    >
      {highOrderAdditionalInfo(segmentMstKey)}
    </MstRegistrationTmpl>
  );
}

const Registration = withRerender(PageComponent, 'Registration');

export { Registration };
